import { Asset } from '@cube3/common/model/schema/resources/asset';
import { Folder } from '@cube3/common/model/schema/resources/folder';

import { useMemo } from 'react';
import { useReviewNodes } from './useReviewNodes';

export type NodeTreeType = {
  [id: string]: (Asset | Folder)[];
};

export const useReviewNodeTree = (
  rootNodeId: string,
  maxItems = -1,
  imageOnly = false
) => {
  const { assets, folders } = useReviewNodes(rootNodeId, false, maxItems);

  const nodeTree = useMemo(() => {
    if (!folders?.length || !assets) return undefined;
    const images = assets.filter(
      (a: Asset) => a.mime_type === 'application/vnd.cube.image'
    );
    const merged = [...folders, ...(imageOnly ? images : assets)];
    return merged.reduce((acc: { [id: string]: (Asset | Folder)[] }, node) => {
      const children = merged.filter(
        (n) => n.relationships.parent?.id === node.id
      );
      acc[node.id] = children;
      return acc;
    }, {});
  }, [folders, assets]);

  return nodeTree;
};
